export const Camera = () => null;
export const useCameraDevice = () => undefined;
export const useCameraPermission = () => ({ hasPermission: true, requestPermission: async () => true });
export const useCodeScanner = () => undefined;
export const useCameraFormat = () => undefined;
export const TurboModuleRegistry = { get: () => null };
export const requireNativeComponent = () => () => null;

export default {};
